module.exports = __webpack_public_path__ + "static/giftingbg-48f3bf71032cb2cb33aaa0e5c892f5d8.jpg";